import React, { useEffect, useRef, useState, useContext } from "react";
import { FaArrowLeft, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { CompanyContext } from "../../../contexts/companyCotext";
import buildLink from "../../../urls";
import axios from "axios";
import MessageAlert from "../../../components/messageAlert";
import { PlaySounds } from "../../../functions/playSounds";
import useDeviceSize from "../../../components/useDeviceSize";
import hocStarredPage from "../../../components/hocStarredPage";
import "swiper/css";
import "swiper/css/pagination";

import ReactPaginate from "react-paginate";
import DateRangeInput from "../../../components/dateRangePicker";
import PointsLoader from "../../../components/PointsLoader";
import { axiosServer } from "../../../axiosServer";

const MissingProducts = () => {
  const permissions = JSON.parse(localStorage.getItem("permissions"));
  const { playErrorSound, playSuccessSound } = PlaySounds();
  const productId = useRef(null);
  const productFoundID = useRef(null);
  const addressID = useRef(null);
  const [loading, setLoading] = useState(false);
  const [MissingProducts, setMissingProducts] = useState([]);
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [message, setMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [show, setShow] = useState(true);
  const [submitFound, setSubmitFound] = useState(false);
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  const [width] = useDeviceSize();
  const [counter, setCounter] = useState(0);
  const [stateCom, dispatchCom] = useContext(CompanyContext);
  const [addresstype, setSelectAddressType] = useState("bin");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [range, setRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  useEffect(() => {
    if (productId.current?.value?.trim()) {
      FilterMisssingProduct(range);
    } else {
      fetchMissingProducts(range);
    }
  }, [range]);

  const FilterMisssingProduct = async (selectedDateValue) => {
    if (selectedDateValue?.preventDefault) selectedDateValue.preventDefault();
    const product_id = productId.current.value;

    try {
      setLoading(true);
      let url = buildLink("missingPickupOrderProduct") + `&label=${product_id}`;
      let startDate = range.startDate.toLocaleDateString("en-CA");
      let endDate = range.endDate.toLocaleDateString("en-CA");
      if (startDate !== "" && endDate !== "") {
        url += `&filter_date_added=${startDate}/${endDate}`;
      }

      const response = await axiosServer.get(url);
      if (response.data.success) {
        setMissingProducts(response.data);
      }
      setLoading(false);
    } catch (e) {
      setMissingProducts([]);
      playErrorSound();
      setLoading(false);
      setMessage(e?.response?.data?.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  };

  const NotFoundProduct = async (e, product) => {
    e.preventDefault();
    const product_id = product.product_id;
    const product_option_value_id = product.product_option_value_id;

    const missingIds = product.missingIds || [product.missing_product_id];

    const promises = missingIds.map((missing_product_id) => {
      const obj = {
        product_id: product_id,
        product_option_value_id: product_option_value_id,
        missing_product_id: missing_product_id,
        user_id: stateCom.userID,
        found: 2,
        found_address_type: "",
        found_address_id: "",
      };

      let url = buildLink("missingPickupOrderProduct");
      return axiosServer.put(url, obj);
    });

    try {
      const responses = await Promise.all(promises);
      const allSuccessful = responses.every(
        (response) => response.data.success
      );

      if (allSuccessful) {
        playSuccessSound();
        setMessage(responses[0].data.message);
        setShowMessageSucc(true);
        setTimeout(() => {
          setShowMessageSucc(false);
        }, 3000);
      } else {
        playErrorSound();
        setMessage(responses[0]?.data?.message);
        setShowMessageErr(true);
        setTimeout(() => setShowMessageErr(false), 3000);
      }
      fetchMissingProducts();
    } catch (e) {
      playErrorSound();
      setMessage(e?.response?.data?.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  };

  const Defected = async (e, product) => {
    e.preventDefault();
    const product_id = product.product_id;
    const product_option_value_id = product.product_option_value_id;

    const missingIds = product.missingIds || [product.missing_product_id];

    const promises = missingIds.map((missing_product_id) => {
      const obj = {
        product_id: product_id,
        product_option_value_id: product_option_value_id,
        missing_product_id: missing_product_id,
        user_id: stateCom.userID,
        found: 3,
        found_address_type: "",
        found_address_id: "",
      };

      let url = buildLink("missingPickupOrderProduct");
      return axiosServer.put(url, obj);
    });

    try {
      const responses = await Promise.all(promises);
      const allSuccessful = responses.every(
        (response) => response.data.success
      );

      if (allSuccessful) {
        playSuccessSound();
        setMessage(responses[0].data.message);
        setShowMessageSucc(true);
        setTimeout(() => {
          setShowMessageSucc(false);
        }, 3000);
      } else {
        playErrorSound();
        setMessage(responses[0]?.data?.message);
        setShowMessageErr(true);
        setTimeout(() => setShowMessageErr(false), 3000);
      }
      fetchMissingProducts();
    } catch (e) {
      playErrorSound();
      setMessage(e?.response?.data?.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const groupProductsBySku = (products) => {
    if (!products) return [];

    const grouped = {};

    products.forEach((product) => {
      const key = product.sku || product.product_id;
      if (!grouped[key]) {
        grouped[key] = {
          ...product,
          quantity: 1,
          missingIds: [product.missing_product_id],
        };
      } else {
        grouped[key].quantity += 1;
        grouped[key].missingIds.push(product.missing_product_id);
      }
    });

    return Object.values(grouped);
  };

  const groupedProducts = groupProductsBySku(MissingProducts.products);
  const paginatedProducts = groupedProducts
    ? groupedProducts.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      )
    : [];

  const totalPages = groupedProducts
    ? Math.ceil(groupedProducts.length / itemsPerPage)
    : 0;

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  const FoundProduct = async () => {
    if (!selectedProduct || !addressID.current?.value.trim()) {
      playErrorSound();
      setShowModal(false);
      setMessage("Address ID or Product ID / SKU / Code are empty");
      setShowMessageErr(true);
      setShowModal(true);
      setTimeout(() => setShowMessageErr(false), 3000);
      return;
    }

    if (counter === 0) {
      playErrorSound();
      setShowModal(false);
      setMessage("No Scanned Product");
      setShowMessageErr(true);
      setShowModal(true);
      setTimeout(() => setShowMessageErr(false), 3000);
      return;
    }
    setShow(true);
    const { product_id, product_option_value_id } = selectedProduct;
    const found_quantity = counter;

    const missingIds = selectedProduct.missingIds || [
      selectedProduct.missing_product_id,
    ];

    const promises = missingIds.map((missing_product_id) => {
      const obj = {
        product_id,
        product_option_value_id,
        missing_product_id,
        user_id: stateCom.userID,
        found: 1,
        found_address_type: addresstype,
        found_address_id: addressID.current.value,
        found_quantity: found_quantity,
      };

      const url = buildLink("missingPickupOrderProduct");
      return axiosServer.put(url, obj);
    });

    try {
      const responses = await Promise.all(promises);
      const allSuccessful = responses.every(
        (response) => response.data.success
      );

      if (allSuccessful) {
        addressID.current = null;
        productFoundID.current = null;
        playSuccessSound();
        setMessage(responses[0].data.message);
        setShowMessageSucc(true);
        setTimeout(() => setShowMessageSucc(false), 3000);
        setShowModal(false);
        setCounter(0);
      } else {
        addressID.current = null;
        productFoundID.current = null;
        playErrorSound();
        setMessage(responses[0]?.data?.message);
        setShowMessageErr(true);
        setTimeout(() => setShowMessageErr(false), 3000);
        setShowModal(false);
        setCounter(0);
      }
      fetchMissingProducts();
    } catch (e) {
      addressID.current = null;
      productFoundID.current = null;
      playErrorSound();
      setShowModal(false);
      setMessage(e?.response?.data?.message);
      setShowMessageErr(true);
      setCounter(0);
      setTimeout(() => setShowMessageErr(false), 3000);
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const history = useNavigate();

  const fetchMissingProducts = async (dateOption) => {
    try {
      setLoading(true);
      let url = buildLink("missingPickupOrderProduct");

      let startDate = range.startDate.toLocaleDateString("en-CA");
      let endDate = range.endDate.toLocaleDateString("en-CA");
      if (startDate !== "" && endDate !== "") {
        url += `&filter_date_added=${startDate}/${endDate}`;
      }
      const response = await axiosServer.get(url);
      if (response.data.success) {
        setMissingProducts(response.data);
      }

      setLoading(false);
    } catch (e) {
      playErrorSound();
      setLoading(false);
      setMessage(e?.response?.data?.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  };

  useEffect(() => {
    if (productId.current) {
      productId.current.focus();
    }
  }, []);

  const handleShowModal = (e, product) => {
    setShow(false);
    setShowModal(true);
    setSelectedProduct(product);
  };

  const checkMatching = () => {
    const { product_id, barcode, sku, product_option_value_id, code, model } =
      selectedProduct;
    const product_found_id = productFoundID.current.value;
    if (product_found_id === "" || addressID.current.value === "") {
      playErrorSound();
      setShowModal(false);
      setMessage("Address ID or Product ID / SKU / Code are empty");
      setShowMessageErr(true);
      setShowModal(true);
      setTimeout(() => setShowMessageErr(false), 3000);
      return;
    }
    if (product_option_value_id !== "" && product_option_value_id != null) {
      if (
        product_found_id === product_option_value_id ||
        product_found_id === code ||
        product_found_id === barcode
      ) {
        setCounter(counter + 1);
        playSuccessSound();
        setMessage(`Product is Scanned`);
        setShowMessageSucc(true);
        setShowModal(true);
        setTimeout(() => setShowMessageSucc(false), 3000);
      } else {
        playErrorSound();
        setShowModal(false);
        setMessage("Product Not Found");
        setShowMessageErr(true);
        setShowModal(true);
        setTimeout(() => setShowMessageErr(false), 3000);
      }
    } else {
      if (
        product_found_id === product_id ||
        product_found_id === sku ||
        product_found_id === model ||
        product_found_id === barcode
      ) {
        setCounter(counter + 1);
        playSuccessSound();
        setMessage(`Product is Scanned`);
        setShowMessageSucc(true);
        setShowModal(true);
        setTimeout(() => setShowMessageSucc(false), 3000);
      } else {
        playErrorSound();
        setShowModal(false);
        setMessage("Product Not Found");
        setShowMessageErr(true);
        setShowModal(true);
        setTimeout(() => setShowMessageErr(false), 3000);
      }
    }
  };

  const handleProductTrashClick = () => {
    productId.current.value = "";
    productId.current.focus();
    fetchMissingProducts();
  };

  return (
    <>
      <div className=" h-full bg-white ">
        {/* header */}
        <div className=" z-30 mb-5 sticky top-0 flex flex-col ">
          <div className=" w-full bg-dbase h-16">
            <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className=" text-xl    my-auto">Missing Products</h2>
            </div>
          </div>
        </div>

        <div className=" container">
          <div className="flex flex-col md:flex-row items-center gap-4">
            <form
              onSubmit={(e) => {
                e.preventDefault(); // Prevent default form submission behavior
                FilterMisssingProduct(); // Pass the correct selected date value
              }}
              className="md:w-3/5 w-full"
            >
              <div className="relative w-full">
                 <div className="mb-1" >Product ID or SKU or Barcode</div>
                <input
                  ref={productId}
                  type="text"
                  className="border border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                  placeholder="Product ID or SKU or Barcode"
                />
                <div>
                  <FaTrash
                    onClick={() => handleProductTrashClick()}
                    className="absolute top-[55px] transform -translate-y-1/2 right-3 cursor-pointer opacity-20"
                  />
                </div>
              </div>
            </form>

            <div className="md:w-2/5 w-full">
            <div className="mb-1" >Date</div>
              <DateRangeInput
                onSelect={(date) => {
                  setRange({
                    startDate: date.startDate,
                    endDate: date.endDate,
                    key: date.keyName,
                  });
                }}
              />
            </div>
          </div>

          {loading ? (
            <PointsLoader />
          ) : (
            <>
              {MissingProducts.products &&
                MissingProducts.products.length !== 0 &&
                show && (
                  <div className="flex flex-wrap justify-between lg:grid lg:grid-cols-3 lg:gap-4 ml-10 lg:ml-0">
                    {paginatedProducts.map((product, index) => (
                      <div key={index} className="w-full lg:w-auto">
                        <div className="flex flex-row rounded-lg overflow-hidden w-full sm:w-1/2 lg:w-full mt-3">
                          <div className="flex-shrink-0">
                            <img
                              src={product.image}
                              alt={product.product_id}
                              className="w-32 h-42 object-cover"
                            />
                          </div>
                          <div className="flex flex-col p-4 mt-3 gap-1 text-sm flex-grow">
                            {product.product_id && (
                              <p>Product ID: {product.product_id}</p>
                            )}
                            {product.sku && <p>SKU: {product.sku}</p>}
                            {product.barcode && (
                              <p>Barcode: {product.barcode}</p>
                            )}
                            {product.address && (
                              <p>Address: {product.address}</p>
                            )}
                            {product.quantity && product.quantity > 1 && (
                              <p className="font-semibold text-dbase">
                                Qty: {product.quantity}
                              </p>
                            )}
                            {product.option_name &&
                              product.option_value_name && (
                                <p>
                                  {product.option_name}:{" "}
                                  {product.option_value_name}
                                </p>
                              )}
                          </div>
                        </div>
                        <div
                          className={`flex mb-3 mt-4 ${
                            permissions.pda_order_missing_products_deffected
                              ? "space-x-4"
                              : "space-x-32"
                          }`}
                        >
                          <button
                            className="bg-dgreen text-white rounded-lg px-2 py-1"
                            onClick={(e) => handleShowModal(e, product)}
                          >
                            Found
                          </button>

                          {permissions.pda_order_missing_products_deffected && (
                            <button
                              className="bg-dblue text-white rounded-lg px-2 py-1"
                              onClick={(e) => Defected(e, product)}
                            >
                              Defected
                            </button>
                          )}

                          <button
                            className="bg-dbase text-white rounded-lg px-2 py-1"
                            onClick={(e) => NotFoundProduct(e, product)}
                          >
                            Not Found
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              {show && (
                <ReactPaginate
                  className={"category-pagination"}
                  pageCount={totalPages}
                  pageRangeDisplayed={1}
                  marginPagesDisplayed={1}
                  onPageChange={handlePageChange}
                  containerClassName={"pagination-buttons"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={
                    "bg-dbase bg-opacity-40  border border-none rounded-lg text-white"
                  }
                  nextLabel=">"
                  previousLabel="<"
                  breakLabel="..."
                  forcePage={currentPage - 1}
                  renderOnZeroPageCount={null}
                />
              )}
            </>
          )}

          {showModal && !show && (
            <>
              <div className="w-full h-full bg-dgreySeller bg-opacity-50 transition-opacity flex fixed inset-0 z-50 outline-none focus:outline-none items-center justify-center">
                <div className="shadow-md absolute w-[350px] mb-48">
                  <div className="transition-transform border-0 rounded-lg shadow-lg flex flex-col w-full bg-white outline-none focus:outline-none">
                    <div className="container flex items-start justify-between p-2 mt-1  ml-1 border-b border-solid border-dgrey rounded-t transform transition-transform">
                      <div className="flex items-center justify-between">
                        <h3 className="text-xl text-dblack font-semibold">
                          Add Address
                        </h3>
                        <div className="text-xl text-dblack font-semibold ml-14 ">
                          <span className="text-dbase">Scanned Qty:</span>{" "}
                          <span className="text-dbase">{counter}</span>
                        </div>
                      </div>
                      <button
                        className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                        onClick={() => setShowModal(false)}
                      ></button>
                    </div>
                    <div className="relative p-2 flex-auto">
                      <Select
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderRadius: "7px",
                            borderColor: state.isFocused ? "grey" : "grey",
                            padding: "8px 5px",
                          }),
                        }}
                        value={{
                          value: addresstype,
                          label:
                            addresstype.charAt(0).toUpperCase() +
                            addresstype.slice(1),
                        }}
                        onChange={(selectedOption) =>
                          setSelectAddressType(selectedOption.value)
                        }
                        options={[
                          { value: "bin", label: "Bin" },
                          { value: "reference", label: "Reference" },
                        ]}
                        defaultValue={{ value: "bin", label: "Bin" }}
                        placeholder="Select Warehouse"
                        className="w-full"
                      />
                    </div>
                    <div className="relative p-2 flex-auto">
                      <input
                        ref={addressID}
                        type="text"
                        className="border border-dlabelColor outline-dbase w-full rounded-md py-3  pl-2"
                        placeholder="Enter Address ID"
                      />
                      <input
                        ref={productFoundID}
                        type="text"
                        className="border border-dlabelColor outline-dbase w-full rounded-md py-3  pl-2 mt-3"
                        placeholder="Enter Product ID or SKU or Code"
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            checkMatching();
                          }
                        }}
                      />
                    </div>
                    <div className="flex items-center justify-end p-3 border-t border-solid border-dgrey rounded-b">
                      <button
                        className="border text-dbase active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mx-auto ease-linear transition-all duration-150"
                        type="button"
                        onClick={() => {
                          closeModal();
                          setShow(true);
                        }}
                      >
                        Cancel
                      </button>

                      <button
                        className="border text-white bg-dbase active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mx-auto ease-linear transition-all duration-150"
                        type="button"
                        onClick={() => {
                          closeModal();
                          FoundProduct();
                          setShow(true);
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        <MessageAlert
          message={message}
          type={showMessgErr ? "err" : "succ"}
          showMessg={showMessgErr || (showMessgSucc && true)}
        />
      </div>
    </>
  );
};

export default hocStarredPage(MissingProducts);
